export enum ModelType {
  CHAT = 'chat',
  COMPLETIONS = 'completions',
  EMBEDDINGS = 'embeddings',
  TEXT_2_IMAGE = 'text2image',
  IMAGE_2_TEXT = 'image2text',
  PLUGIN = 'plugin',
  RERANKER = 'reranker'
}

export enum APIErrorCode {
    NoError = 0,
    UnknownError = 1,
    ServiceUnavailable = 2,
    UnsupportedMethod = 3,
    RequestLimitReached = 4,
    NoPermissionToAccessData = 6,
    GetServiceTokenFailed = 13,
    AppNotExist = 15,
    DailyLimitReached = 17,
    QPSLimitReached = 18,
    TotalRequestLimitReached = 19,
    InvalidRequest = 100,
    APITokenInvalid = 110,
    APITokenExpired = 111,
    InternalError = 336000,
    InvalidArgument = 336001,
    InvalidJSON = 336002,
    InvalidParam = 336003,
    PermissionError = 336004,
    APINameNotExist = 336005,
    ServerHighLoad = 336100,
    InvalidHTTPMethod = 336101,
    InvalidArgumentSystem = 336104,
    InvalidArgumentUserSetting = 336105,
    RPMLimitReached = 336501,
    TPMLimitReached = 336502,
    ConsoleInternalError = 500000,
  }